import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const navHTML = `
<style>
@media (max-width: 991px) { 
    .desktop-nav { display: none !important; } 
    .header-inner-grid { grid-template-columns: 1fr !important; }
}
@media (min-width: 992px) { .menu-button { display: none !important; } }
</style>
<div class="page-wrapper"><div data-animation="default" data-collapse="all" data-duration="0" data-easing="ease" data-easing2="ease" role="banner" class="navbar w-nav"><div class="padding-global"><div class="container-large w-container"><div class="navbar-content-wrapper"><a href="/" class="logo-link w-nav-brand w--current" aria-label="home"><div style="font-size: 1.25rem; font-weight: 700; color: #274c77; letter-spacing: -0.02em;">CA Ronak Patel</div></a><div class="desktop-nav" style="display: flex; gap: 2.5rem; align-items: center;"><a href="/" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Home</a><a href="/#services" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Services</a><a href="/#software" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Software</a><a href="/#faq" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">FAQ</a><a href="/#contact" style="color: #475569; font-weight: 500; font-size: 1rem; text-decoration: none;">Contact</a><a href="/login" style="background-color: #274c77; color: white; padding: 0.5rem 1.25rem; border-radius: 0.5rem; font-weight: 600; text-decoration: none; transition: background-color 0.2s;" onMouseOver="this.style.backgroundColor='#1a365d'" onMouseOut="this.style.backgroundColor='#274c77'">Login</a></div><nav id="mobile-nav" role="navigation" class="nav-menu w-nav-menu" style="display: none; background-color: #e2e8f0; position: absolute; top: 100%; left: 0; width: 100%; z-index: 1000;"><div class="nav-menu-container" style="opacity: 1; height: auto; min-height: 100vh; padding-top: 5vh; gap: 1rem;"><a href="/" onclick="document.getElementById('mobile-nav').style.display='none'" aria-current="page" class="nav-link w-inline-block w--current"><div>Home</div></a><a href="/#services" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Services</div></a><a href="/#software" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Software</div></a><a href="/#faq" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>FAQ</div></a><a href="/#contact" onclick="document.getElementById('mobile-nav').style.display='none'" class="nav-link w-inline-block"><div>Contact</div></a><a href="/login" class="nav-link w-inline-block" style="background-color: #274c77; color: white; padding: 0.5rem 1.25rem; border-radius: 0.5rem; width: auto; margin-top: 1rem;"><div style="color: white; text-align: center;">Login</div></a></div></nav><div onclick="var nav = document.getElementById('mobile-nav'); if(nav.style.display === 'none'){nav.style.display = 'flex';}else{nav.style.display = 'none';}" class="menu-button w-nav-button" style="-webkit-user-select: text;" aria-label="menu" role="button" tabindex="0" aria-controls="w-nav-overlay-0" aria-haspopup="menu" aria-expanded="false"><div class="inner-menu-button"><div class="menu-line-container"><div class="menu-line-wrap"><div class="top-dash"></div></div><div class="menu-line-wrap"><div class="middle-dash"></div></div><div class="menu-line-wrap"><div class="bottom-dash"></div></div></div></div></div></div></div></div></div><div class="w-nav-overlay" data-wf-ignore="" id="w-nav-overlay-0"></div></div>`;

const footerHTML = `<footer class="footer"><div class="padding-global"><div class="w-layout-blockcontainer container-large w-container"><div class="footer-padding"><div class="footer-bottom-wrapper"><div class="footer-link-block"><div class="footer_credit-text">Designed for CA Ronak Patel</div><div class="footer_credit-text">All Rights Reserved © 2026</div></div><div class="footer-link-block"><a href="/privacy-policy" class="footer-legal-link">Privacy Policy</a><a href="/terms-of-service" class="footer-legal-link">Terms of Service</a></div></div></div></div></div></footer>`;

const EFFECTIVE_DATE = "7 June 2026";
const CONTROLLER_NAME = "CA Ronak Patel (Chartered Accountant)";
const CONTROLLER_EMAIL = "notifications@caronakpatel.com";
const CONTROLLER_ADDRESS = "India (Registered Practice)";

const sections = [
  {
    id: "overview",
    title: "1. Overview & Scope",
    content: (
      <>
        <p>This Privacy Policy ("Policy") governs the collection, processing, storage, transfer, and deletion of personal data by <strong>{CONTROLLER_NAME}</strong> ("we," "our," "us") through the website <strong>caronakpatel.com</strong> and its associated client portal (collectively, the "Platform").</p>
        <p style={{ marginTop: "1rem" }}>This Policy is designed to comply with the applicable data protection laws of the jurisdictions in which we operate and serve clients, including but not limited to:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.4rem" }}>
          <li><strong>India:</strong> Digital Personal Data Protection Act, 2023 (DPDPA) and IT Act, 2000 and its Rules</li>
          <li><strong>European Union / EEA:</strong> General Data Protection Regulation (GDPR) – Regulation (EU) 2016/679</li>
          <li><strong>United Kingdom:</strong> UK GDPR and the Data Protection Act 2018</li>
          <li><strong>United States – California:</strong> California Consumer Privacy Act (CCPA) as amended by the CPRA 2020</li>
          <li><strong>Canada:</strong> Personal Information Protection and Electronic Documents Act (PIPEDA) and provincial equivalents</li>
          <li><strong>Australia:</strong> Privacy Act 1988 (as amended) and Australian Privacy Principles (APPs)</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>By accessing or using the Platform, you acknowledge that you have read, understood, and agree to be bound by this Policy. If you disagree with any part of this Policy, please discontinue use of the Platform immediately.</p>
      </>
    ),
  },
  {
    id: "data-controller",
    title: "2. Data Controller / Fiduciary Identity",
    content: (
      <>
        <p>For the purposes of applicable data protection law, the Data Controller (or "Data Fiduciary" under India's DPDPA) is:</p>
        <div style={{ background: "#f1f5f9", borderLeft: "4px solid #274c77", padding: "1rem 1.5rem", borderRadius: "0 0.5rem 0.5rem 0", marginTop: "1rem" }}>
          <p><strong>Name:</strong> {CONTROLLER_NAME}</p>
          <p><strong>Email:</strong> <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a></p>
          <p><strong>Address:</strong> {CONTROLLER_ADDRESS}</p>
          <p><strong>Nature of Practice:</strong> Virtual / Remote Chartered Accountancy, Bookkeeping & Tax Advisory</p>
        </div>
        <p style={{ marginTop: "1rem" }}>We do not currently appoint a dedicated Data Protection Officer (DPO); however, all data-related enquiries, complaints, and rights requests are handled directly by the practice principal and may be directed to the email above.</p>
      </>
    ),
  },
  {
    id: "data-collected",
    title: "3. Personal Data We Collect",
    content: (
      <>
        <p>We collect personal data through multiple touchpoints on the Platform. The categories of data collected are:</p>
        <div style={{ marginTop: "1rem", display: "flex", flexDirection: "column", gap: "1rem" }}>
          {[
            {
              cat: "A. Account & Identity Data",
              items: ["Full name", "Email address", "Phone number", "Profile photograph (if provided)", "Government-issued ID numbers (where required for professional engagements, e.g., PAN, Aadhaar – collected in compliance with applicable Indian law)", "Google OAuth profile data (email, name, avatar – when using social login)"]
            },
            {
              cat: "B. Financial & Tax Data",
              items: ["Income details, tax filings, bank statements", "Business financial records (ledgers, trial balances, invoices)", "GST/VAT/TIN registration information", "Foreign remittance and NRI-related financial data"]
            },
            {
              cat: "C. Communication Data",
              items: ["Messages and correspondence sent through the contact form", "Email communications with our practice", "Uploaded documents and attachments"]
            },
            {
              cat: "D. Technical & Usage Data",
              items: ["IP address", "Browser type and version", "Device type and operating system", "Pages visited and time spent on Platform", "Referring URLs", "Session identifiers and cookies (see Section 9)"]
            },
            {
              cat: "E. Sensitive Personal Data (where applicable)",
              items: ["Biometric data (only where required by statute for client identification)", "Financial health / creditworthiness data (in the context of professional engagements)", "We do not collect racial, ethnic, religious, political, or health data unless directly relevant to a professional mandate and with explicit consent."]
            },
          ].map((block) => (
            <div key={block.cat}>
              <p><strong>{block.cat}</strong></p>
              <ul style={{ paddingLeft: "1.5rem", marginTop: "0.4rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.3rem" }}>
                {block.items.map((item) => <li key={item}>{item}</li>)}
              </ul>
            </div>
          ))}
        </div>
        <p style={{ marginTop: "1rem" }}>We collect data <strong>only to the extent necessary</strong> for the specified purpose (principle of data minimisation / purpose limitation).</p>
      </>
    ),
  },
  {
    id: "legal-basis",
    title: "4. Legal Basis for Processing",
    content: (
      <>
        <p>We process your personal data on one or more of the following lawful bases, depending on the applicable jurisdiction:</p>
        <div style={{ overflowX: "auto", marginTop: "1rem" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.95rem" }}>
            <thead>
              <tr style={{ background: "#274c77", color: "white" }}>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>Purpose</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>GDPR Basis</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>India DPDPA Basis</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Account creation & portal access", "Contract (Art. 6(1)(b))", "Consent / Contract"],
                ["Delivering accounting & tax services", "Contract (Art. 6(1)(b))", "Contract"],
                ["Complying with tax/legal obligations", "Legal obligation (Art. 6(1)(c))", "Legal obligation"],
                ["Fraud prevention & security", "Legitimate interests (Art. 6(1)(f))", "Legitimate uses"],
                ["Marketing communications (opt-in only)", "Consent (Art. 6(1)(a))", "Consent"],
                ["Resolving disputes / legal claims", "Legitimate interests / Legal obligation", "Legal obligation"],
              ].map(([purpose, gdpr, dpdpa], i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? "#f8fafc" : "white", borderBottom: "1px solid #e2e8f0" }}>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{purpose}</td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{gdpr}</td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{dpdpa}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{ marginTop: "1rem" }}>Where we rely on <strong>consent</strong>, you have the right to withdraw it at any time without affecting the lawfulness of processing prior to withdrawal.</p>
      </>
    ),
  },
  {
    id: "how-we-use",
    title: "5. How We Use Your Personal Data",
    content: (
      <>
        <p>We use the personal data we collect for the following purposes:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <li>To create and manage your secure client account on the Portal</li>
          <li>To deliver bookkeeping, accounting, and income tax advisory services as contracted</li>
          <li>To prepare, review, and file Income Tax Returns (ITR), GST returns, and other statutory filings</li>
          <li>To communicate with you regarding service delivery, document requests, and deadlines</li>
          <li>To authenticate your identity and prevent unauthorised access</li>
          <li>To generate financial reports, balance sheets, and audit-ready statements</li>
          <li>To comply with legal, regulatory, and professional obligations (ICAI guidelines, Income Tax Act, Companies Act, etc.)</li>
          <li>To send service notifications, updates, and (where consented) newsletters</li>
          <li>To monitor Platform security, detect fraud, and investigate suspicious activities</li>
          <li>To improve Platform functionality through aggregated, anonymised analytics</li>
          <li>To fulfil obligations under applicable anti-money laundering (AML) and Know Your Customer (KYC) regulations</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>We will <strong>never</strong> use your personal data for automated individual decision-making or profiling that produces legal or similarly significant effects without your explicit consent.</p>
      </>
    ),
  },
  {
    id: "data-sharing",
    title: "6. Data Sharing & Disclosure",
    content: (
      <>
        <p>We do not sell, rent, or trade your personal data. We may share it only in the following limited circumstances:</p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.8rem", marginTop: "1rem" }}>
          {[
            { title: "Service Providers & Processors", desc: "We engage trusted third-party processors (e.g., cloud hosting providers, accounting software platforms such as Zoho, Xero, QuickBooks, and Tally) who process data strictly on our instructions under written data processing agreements." },
            { title: "Government & Regulatory Authorities", desc: "We may disclose data where required by law, court order, or government authority — including the Income Tax Department, MCA, GSTN, SEBI, or equivalent authorities in other jurisdictions." },
            { title: "Professional Bodies", desc: "Disclosures required under ICAI professional standards or similar regulatory oversight bodies." },
            { title: "Business Succession", desc: "In the event of a merger, acquisition, or sale of practice, your data may be transferred with appropriate notice and continuation of this Policy's protections." },
            { title: "With Your Consent", desc: "We may share data in any other manner with your explicit prior consent." },
            { title: "Legal Defence", desc: "To establish, exercise, or defend legal claims involving the practice." },
          ].map((item) => (
            <div key={item.title} style={{ background: "#f8fafc", padding: "0.8rem 1rem", borderRadius: "0.5rem", borderLeft: "3px solid #145886" }}>
              <p><strong>{item.title}:</strong> {item.desc}</p>
            </div>
          ))}
        </div>
      </>
    ),
  },
  {
    id: "cross-border",
    title: "7. Cross-Border Data Transfers",
    content: (
      <>
        <p>As a virtual practice serving clients globally, data may be transferred to and processed in countries outside your jurisdiction, including India, the United States, and the European Economic Area. Such transfers are carried out with appropriate safeguards including:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <li><strong>GDPR (EU/UK):</strong> Standard Contractual Clauses (SCCs) or adequacy decisions where applicable</li>
          <li><strong>India DPDPA:</strong> Transfers to countries notified by the Central Government as permissible; data localisation requirements observed where mandated</li>
          <li><strong>CCPA / US:</strong> Compliance with applicable US federal and state privacy frameworks</li>
          <li><strong>PIPEDA (Canada):</strong> Comparable protection standards via contractual obligations</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>You may request details of the specific safeguards in place for any particular cross-border transfer by contacting us.</p>
      </>
    ),
  },
  {
    id: "retention",
    title: "8. Data Retention",
    content: (
      <>
        <p>We retain personal data for as long as necessary to fulfil the purposes for which it was collected, or as required by applicable law. Our standard retention framework is:</p>
        <div style={{ overflowX: "auto", marginTop: "1rem" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.95rem" }}>
            <thead>
              <tr style={{ background: "#274c77", color: "white" }}>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>Data Category</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>Retention Period</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>Basis</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Tax filings & financial records", "8 years from filing date", "Income Tax Act / Companies Act"],
                ["GST records", "8 years from relevant assessment year", "CGST Act, 2017"],
                ["Client account data", "Duration of engagement + 3 years", "Contractual / Regulatory"],
                ["Communication records", "3 years", "Legitimate interests"],
                ["Server/access logs", "90 days rolling", "Security"],
                ["Consent records", "Until withdrawal + 3 years", "Legal obligation"],
                ["KYC/AML documentation", "5 years post-engagement end", "PMLA, 2002"],
              ].map(([cat, ret, basis], i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? "#f8fafc" : "white", borderBottom: "1px solid #e2e8f0" }}>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{cat}</td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{ret}</td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{basis}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{ marginTop: "1rem" }}>After the applicable retention period, data is securely deleted or anonymised in accordance with industry-standard procedures.</p>
      </>
    ),
  },
  {
    id: "cookies",
    title: "9. Cookies & Tracking Technologies",
    content: (
      <>
        <p>We use cookies and similar tracking technologies to enhance your experience on the Platform. The categories of cookies we use are:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <li><strong>Strictly Necessary Cookies:</strong> Essential for Portal authentication, session management, and security. Cannot be disabled.</li>
          <li><strong>Functional Cookies:</strong> Remember your preferences (e.g., language, display settings).</li>
          <li><strong>Analytics Cookies:</strong> Aggregate, anonymised data on how users interact with the Platform (e.g., Google Analytics with IP anonymisation enabled). These are only set with your consent.</li>
          <li><strong>Security Cookies:</strong> Used by Cloudflare and similar infrastructure providers to protect against bots and malicious activity.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>You may manage cookie preferences through your browser settings or a consent management tool where deployed. Disabling non-essential cookies will not impair core Portal functionality.</p>
      </>
    ),
  },
  {
    id: "security",
    title: "10. Data Security",
    content: (
      <>
        <p>We implement a robust, multi-layered security framework to protect your personal data from unauthorised access, disclosure, alteration, and destruction. Our measures include:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <li><strong>Encryption:</strong> AES-256 encryption for data at rest; TLS 1.3 for data in transit</li>
          <li><strong>Infrastructure:</strong> Hosted on Cloudflare-protected servers with WAF, DDoS mitigation, and real-time threat detection</li>
          <li><strong>Access Controls:</strong> Role-based access control (RBAC); multi-factor authentication (MFA) for administrative access</li>
          <li><strong>Authentication:</strong> Secure OAuth 2.0 / Google Sign-In; bcrypt-hashed passwords</li>
          <li><strong>Audit Trails:</strong> All access to client data is logged and auditable</li>
          <li><strong>Vendor Security:</strong> All third-party processors are vetted for security compliance</li>
          <li><strong>Incident Response:</strong> A documented breach notification procedure with legally mandated timelines (72 hours for GDPR; as prescribed under DPDPA rules)</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Despite these measures, no internet-based system can guarantee absolute security. You should protect your login credentials and notify us immediately at <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a> if you suspect unauthorised access.</p>
      </>
    ),
  },
  {
    id: "your-rights",
    title: "11. Your Data Subject Rights",
    content: (
      <>
        <p>Depending on your jurisdiction, you may have the following rights regarding your personal data. We honour all applicable rights under each law:</p>
        <div style={{ overflowX: "auto", marginTop: "1rem" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.9rem" }}>
            <thead>
              <tr style={{ background: "#274c77", color: "white" }}>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>Right</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>GDPR</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>India DPDPA</th>
                <th style={{ padding: "0.6rem 0.8rem", textAlign: "left" }}>CCPA</th>
              </tr>
            </thead>
            <tbody>
              {[
                ["Right to Access", "✓ Art. 15", "✓ S. 11", "✓"],
                ["Right to Correction / Rectification", "✓ Art. 16", "✓ S. 12", "✓"],
                ["Right to Erasure ('Right to be Forgotten')", "✓ Art. 17", "✓ S. 12", "✓ (Right to Delete)"],
                ["Right to Restrict Processing", "✓ Art. 18", "Partial", "—"],
                ["Right to Data Portability", "✓ Art. 20", "—", "✓"],
                ["Right to Object / Opt-Out", "✓ Art. 21", "✓ S. 13", "✓ (Opt-out of Sale)"],
                ["Right to withdraw Consent", "✓ Art. 7(3)", "✓ S. 6", "✓"],
                ["Right against Automated Decision-Making", "✓ Art. 22", "—", "—"],
                ["Right to Nominate (on death/incapacity)", "—", "✓ S. 14", "—"],
                ["Right to Grievance Redressal", "✓ (via DPA)", "✓ S. 13 / DPBI", "✓ (via AG)"],
              ].map(([right, gdpr, dpdpa, ccpa], i) => (
                <tr key={i} style={{ background: i % 2 === 0 ? "#f8fafc" : "white", borderBottom: "1px solid #e2e8f0" }}>
                  <td style={{ padding: "0.6rem 0.8rem" }}><strong>{right}</strong></td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{gdpr}</td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{dpdpa}</td>
                  <td style={{ padding: "0.6rem 0.8rem" }}>{ccpa}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <p style={{ marginTop: "1rem" }}>To exercise any of the above rights, submit a written request to <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a>. We will respond within the legally required timeframe (generally <strong>30 days</strong>, extendable by a further 30 days for complex requests with prior notice). We may ask you to verify your identity before fulfilling a request.</p>
        <p style={{ marginTop: "1rem" }}>Exercising these rights is free of charge. However, we may charge a reasonable fee or decline manifestly unfounded or excessive requests.</p>
      </>
    ),
  },
  {
    id: "minors",
    title: "12. Children's Privacy",
    content: (
      <>
        <p>The Platform is not directed to individuals under the age of <strong>18</strong> (or the applicable age of digital consent in your jurisdiction). We do not knowingly collect personal data from children.</p>
        <p style={{ marginTop: "1rem" }}>Under India's DPDPA, we do not process personal data of children without verifiable parental consent, and we do not engage in behavioural tracking of children.</p>
        <p style={{ marginTop: "1rem" }}>If you believe we have inadvertently collected data from a minor, please contact us immediately at <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a> and we will promptly delete such data.</p>
      </>
    ),
  },
  {
    id: "grievance",
    title: "13. Grievance Redressal",
    content: (
      <>
        <p>In accordance with the Information Technology Act, 2000 and the Digital Personal Data Protection Act, 2023 (India), a <strong>Grievance Officer</strong> has been designated to address any complaints or concerns about data privacy:</p>
        <div style={{ background: "#f1f5f9", borderLeft: "4px solid #274c77", padding: "1rem 1.5rem", borderRadius: "0 0.5rem 0.5rem 0", marginTop: "1rem" }}>
          <p><strong>Name:</strong> CA Ronak Patel</p>
          <p><strong>Email:</strong> <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a></p>
          <p><strong>Response Time:</strong> Within 30 days of receipt of complaint</p>
        </div>
        <p style={{ marginTop: "1rem" }}>If you are an EU/UK resident and are unsatisfied with our response, you have the right to lodge a complaint with your local <strong>Data Protection Authority (DPA)</strong> — e.g., the Information Commissioner's Office (ICO) in the UK, or the relevant EU supervisory authority.</p>
        <p style={{ marginTop: "1rem" }}>If you are in India and remain unsatisfied with our Grievance Officer's response, you may escalate to the <strong>Data Protection Board of India (DPBI)</strong> once it is constituted and operational.</p>
      </>
    ),
  },
  {
    id: "ccpa-notice",
    title: "14. California Residents – CCPA/CPRA Notice",
    content: (
      <>
        <p>If you are a California resident, you have specific rights under the California Consumer Privacy Act (CCPA) as amended by the CPRA:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <li><strong>Right to Know:</strong> You may request disclosure of the categories and specific pieces of personal information we have collected about you over the past 12 months.</li>
          <li><strong>Right to Delete:</strong> You may request deletion of your personal information, subject to certain exceptions.</li>
          <li><strong>Right to Correct:</strong> You may request correction of inaccurate personal information.</li>
          <li><strong>Right to Opt-Out of Sale/Sharing:</strong> We do <strong>not</strong> sell or share personal information for cross-context behavioural advertising.</li>
          <li><strong>Right to Limit Use of Sensitive Personal Information:</strong> You may request limitation of the use and disclosure of sensitive personal information.</li>
          <li><strong>Right to Non-Discrimination:</strong> You will not receive discriminatory treatment for exercising your CCPA rights.</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>To submit a CCPA rights request, email us at <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a> with "CCPA Request" in the subject line. We will respond within 45 days, extendable by a further 45 days with notice.</p>
      </>
    ),
  },
  {
    id: "third-party",
    title: "15. Third-Party Links & Integrations",
    content: (
      <>
        <p>The Platform may contain links to or integrations with third-party websites or services (e.g., LinkedIn, accounting software providers). We are not responsible for the privacy practices of those third parties. We encourage you to review their privacy policies before submitting any data to them.</p>
        <p style={{ marginTop: "1rem" }}>Third-party integrations used on the Platform (e.g., Zoho, Xero, QuickBooks, Tally) operate under their own privacy policies and terms. Where we share data with them as part of delivering our services, they act as data processors under our instruction.</p>
      </>
    ),
  },
  {
    id: "changes",
    title: "16. Changes to This Policy",
    content: (
      <>
        <p>We reserve the right to update or amend this Privacy Policy at any time. When we make material changes, we will:</p>
        <ul style={{ paddingLeft: "1.5rem", marginTop: "0.75rem", listStyleType: "disc", display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <li>Update the "Effective Date" at the top of this Policy</li>
          <li>Post a prominent notice on the Platform</li>
          <li>Notify registered users by email where required by applicable law</li>
        </ul>
        <p style={{ marginTop: "1rem" }}>Your continued use of the Platform after any changes constitutes your acknowledgement of the modified Policy. If you disagree with the changes, you may close your account by contacting us.</p>
      </>
    ),
  },
  {
    id: "contact",
    title: "17. Contact Us",
    content: (
      <>
        <p>For all privacy-related enquiries, data subject requests, grievances, or consent withdrawals, please contact us:</p>
        <div style={{ background: "#f1f5f9", borderLeft: "4px solid #274c77", padding: "1rem 1.5rem", borderRadius: "0 0.5rem 0.5rem 0", marginTop: "1rem" }}>
          <p><strong>CA Ronak Patel</strong> (Data Fiduciary / Controller)</p>
          <p><strong>Email:</strong> <a href={`mailto:${CONTROLLER_EMAIL}`} style={{ color: "#145886" }}>{CONTROLLER_EMAIL}</a></p>
          <p><strong>Practice:</strong> Virtual / Remote – India</p>
          <p><strong>Response Time:</strong> Within 30 calendar days</p>
        </div>
      </>
    ),
  },
];

const sectionH2Style = { fontSize: "1.35rem", fontWeight: "700", color: "#274c77", marginBottom: "0.75rem" };

export default function PrivacyPolicy() {
  const [activeSection, setActiveSection] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    const navbar = document.querySelector(".navbar");
    if (navbar) {
      const links = navbar.querySelectorAll("a");
      links.forEach((link) => {
        link.addEventListener("click", (e) => {
          const href = link.getAttribute("href");
          if (!href || href.startsWith("http")) return;
          e.preventDefault();
          if (href === "/" || href === "#") {
            navigate("/");
          } else if (href.startsWith("/#")) {
            const targetId = href.split("#")[1];
            navigate("/");
            setTimeout(() => {
              const el = document.getElementById(targetId);
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }, 150);
          } else {
            navigate(href);
          }
        });
      });
    }
  }, [navigate]);

  return (
    <div style={{ backgroundColor: "#e2e8f0", minHeight: "100vh" }}>
      <div dangerouslySetInnerHTML={{ __html: navHTML }} />
      <main className="main-wrapper">
        <section className="section" style={{ paddingTop: "6rem", paddingBottom: "4rem" }}>
          <div className="padding-global">
            <div className="w-layout-blockcontainer container-large w-container">

              {/* Header */}
              <div className="shadow-box medium-padding" style={{ marginBottom: "2rem", background: "linear-gradient(135deg, #274c77 0%, #145886 100%)", color: "white", borderRadius: "1rem", padding: "2.5rem" }}>
                <h1 style={{ color: "white", fontSize: "2.5rem", fontWeight: "800", marginBottom: "0.5rem" }}>Privacy Policy</h1>
                <p style={{ color: "rgba(255,255,255,0.8)", fontSize: "1rem" }}>
                  <strong>Effective Date:</strong> {EFFECTIVE_DATE} &nbsp;|&nbsp;
                  <strong>Jurisdiction:</strong> India, EU/EEA, UK, USA (CA), Canada, Australia
                </p>
                <p style={{ color: "rgba(255,255,255,0.7)", fontSize: "0.9rem", marginTop: "0.5rem" }}>
                  Compliant with: DPDPA 2023 • GDPR • UK GDPR • CCPA/CPRA • PIPEDA • APPs
                </p>
              </div>

              {/* TOC */}
              <div className="shadow-box medium-padding" style={{ marginBottom: "2rem", padding: "1.5rem" }}>
                <h2 style={{ ...sectionH2Style, marginBottom: "1rem", fontSize: "1.1rem" }}>Table of Contents</h2>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))", gap: "0.4rem" }}>
                  {sections.map((s, i) => (
                    <a
                      key={s.id}
                      href={`#${s.id}`}
                      style={{ color: "#145886", textDecoration: "none", fontSize: "0.9rem", padding: "0.2rem 0", display: "block" }}
                      onMouseOver={(e) => e.target.style.textDecoration = "underline"}
                      onMouseOut={(e) => e.target.style.textDecoration = "none"}
                    >
                      {s.title}
                    </a>
                  ))}
                </div>
              </div>

              {/* Sections */}
              {sections.map((s) => (
                <div
                  key={s.id}
                  id={s.id}
                  className="shadow-box medium-padding"
                  style={{ marginBottom: "1.5rem", padding: "2rem", textAlign: "left", scrollMarginTop: "6rem" }}
                >
                  <h2 style={sectionH2Style}>{s.title}</h2>
                  <div style={{ color: "#475569", lineHeight: "1.8", fontSize: "1rem" }}>
                    {s.content}
                  </div>
                </div>
              ))}

              {/* Disclaimer */}
              <div style={{ background: "#fef9c3", border: "1px solid #fbbf24", borderRadius: "0.75rem", padding: "1.25rem 1.5rem", marginBottom: "2rem" }}>
                <p style={{ color: "#92400e", fontSize: "0.9rem" }}>
                  <strong>⚠️ Legal Disclaimer:</strong> This Privacy Policy is prepared in good faith to reflect the data practices of this professional practice. It is not a substitute for formal legal counsel. Clients with specific jurisdictional concerns are advised to consult a qualified privacy attorney.
                </p>
              </div>

            </div>
          </div>
        </section>
      </main>
      <div dangerouslySetInnerHTML={{ __html: footerHTML }} />
    </div>
  );
}
